document
  .querySelector("form#category-search")
  .addEventListener("submit", function(e) {
    e.preventDefault();
    var category = document.querySelector("#category").value || "";
    var categoryQuery = category != "" ? "?category=" + category : "";
    window.location.href =
      window.location.pathname + categoryQuery + "#articles";
  });
